import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';

import 'moment/locale/es';
import 'moment/locale/tr';
import 'moment/locale/zh-cn';
import 'moment/locale/hi';
import 'moment/locale/pt';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/ar';

import en from '../locales/en/common.json';
import es from '../locales/es/common.json';
import tr from '../locales/tr/common.json';
import zh from '../locales/zh/common.json';
import hi from '../locales/hi/common.json';
import pt from '../locales/pt/common.json';
import fr from '../locales/fr/common.json';
import it from '../locales/it/common.json';
import ar from '../locales/ar/common.json';

const STORAGE_KEY = 'reputeloLanguage';
const DEFAULT_LANGUAGE = 'en';
const RTL_LANGS = ['ar'];

const resources = {
  en: { translation: en },
  es: { translation: es },
  tr: { translation: tr },
  zh: { translation: zh },
  hi: { translation: hi },
  pt: { translation: pt },
  fr: { translation: fr },
  it: { translation: it },
  ar: { translation: ar },
};

const momentLocaleMap = {
  en: 'en',
  es: 'es',
  tr: 'tr',
  zh: 'zh-cn',
  hi: 'hi',
  pt: 'pt',
  fr: 'fr',
  it: 'it',
  ar: 'ar',
};

const getStoredLanguage = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(STORAGE_KEY);
};

const initialLanguage = getStoredLanguage() || DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: Object.keys(resources),
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

const applyLanguageSideEffects = language => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
    document.documentElement.dir = RTL_LANGS.includes(language) ? 'rtl' : 'ltr';
  }
  moment.locale(momentLocaleMap[language] || DEFAULT_LANGUAGE);
};

applyLanguageSideEffects(i18n.language);

i18n.on('languageChanged', language => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, language);
  }
  applyLanguageSideEffects(language);
});

export default i18n;

